import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { Suspense, lazy } from "react";

// Lazy loaded components for code splitting
const LandingPage = lazy(() => import("@/pages/LandingPage"));
const InvoiceBuilder = lazy(() => import("@/pages/InvoiceBuilder"));
const InvoiceHistory = lazy(() => import("@/pages/InvoiceHistory"));
const DashboardPage = lazy(() => import("@/pages/DashboardPage"));
const RelancesPage = lazy(() => import("@/pages/RelancesPage"));
const PricingPage = lazy(() => import("@/pages/PricingPage"));

// Eagerly loaded components (small, critical for auth flow)
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import LegalPage from "@/pages/LegalPage";
import ClientSignaturePage from "@/pages/ClientSignaturePage";

// Loading fallback component
function PageLoader() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-violet-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-muted-foreground text-sm">Chargement...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/app" element={<InvoiceBuilder />} />
              <Route path="/history" element={<InvoiceHistory />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/relances" element={<RelancesPage />} />
              <Route path="/legal" element={<LegalPage />} />
              {/* Public signature page for clients */}
              <Route path="/sign/:token" element={<ClientSignaturePage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
